import {aiConfig as getAiConfig} from "@/ai-api/aiConfigApi";

import AiAuthUtil from '@/utils/AiAuthUtil'
import qs from 'qs'
import {AiModelEnum, AiUtilTypeEnum} from '@/ai-api/type-ai'
import {HistoryTextMessage} from '@/ai-api/historyTextApi'
import {message} from "antd";

export type TextResult = {
    reasoning: HistoryTextMessage['reasoning']
    content: HistoryTextMessage['content']
    isEnd: boolean
}

export type AiForm = {
    clientId: string
    model: AiModelEnum
}

export type AiAuthForm = AiForm & {
    authCode: string
}

export type TextForm = Partial<AiAuthForm> & {
    utilType?: AiUtilTypeEnum
    textUtilId?: number
    role: string
    content: string
    onOpen?: () => void
    onMessage?: (chatResult: TextResult) => void
    onEnd?: () => void
    onError?: (errMsg: string) => void
}

export async function text(
    {
        onOpen = () => {
        },
        onMessage = (chatResult) => {
        },
        onEnd = () => {
        },
        onError = (event) => {
        },
        ...textParams
    }: TextForm
) {

    const clientId = AiAuthUtil.getClientId()
    const aiConfig = await getAiConfig()

    const authCode = aiConfig.authCode
    // const clientId = AiAuthUtil.getClientId()

    if (!clientId) {
        throw Error('ai chat 没登录，无法问问题')
    }
    const form: {
        authCode: string
        clientId: string
    } & Omit<TextForm, 'onOpen' | 'onMessage' | 'onEnd' | 'onError'> = {
        ...textParams,
        authCode,
        clientId
    }

    //要传 token
    const eventSource = new EventSource(`${import.meta.env.VITE_AI_API_BASE_URL}/sse/ai/text?${qs.stringify(form)}`)

    eventSource.addEventListener('open', (event: Event) => {
        onOpen()
    })

    eventSource.addEventListener('message', (event: MessageEvent<string>) => {
        const glxResult: TextResult = JSON.parse(event.data)

        console.log(`收到ai回答:${JSON.stringify(glxResult)}`)
        onMessage(glxResult)
    })

    eventSource.addEventListener('end', (event: Event) => {
        onEnd()
        eventSource.close()
    })

    eventSource.addEventListener('error', (event: MessageEvent<string>) => {
        const errMsg = event.data
        message.error(errMsg)
        onError(errMsg)
        eventSource?.close()
    })


    return eventSource
}
